
import { useState } from "react";

const videos = [
  {
    id: "A2zNfayxKLg",
    si: "ES5u83jEWGOZtnZk",
    title: "MG ZS EV: Choice of the professionals?",
  },
  {
    id: "4kmbpZK7_mk",
    si: "YvlIWCllsA232n5S",
    title: "MG ZS EV 2022 Drive Impressions | Gagan Choudhary",
  },
  {
    id: "6_3mRhvxKD8",
    si: "RwDmvmOrr_WKBcAI",
    title:
      "Delhi to Mussoorie in an MG ZS EV - All Charged Up! | Special Feature | Autocar India",
  },
];

const css = `
  @import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;600;700&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

  .ag-section {
    font-family: 'Open Sans', Arial, sans-serif;
    background: #fff;
    padding: 40px 0 48px;
    overflow: hidden;
  }

  .ag-page-title {
    text-align: center;
    font-family: 'Open Sans', Arial, sans-serif;
    font-size: 1.75rem;
    font-weight: 700;
    color: #CF2230;
    margin-bottom: 28px;
  }

  .ag-main-container {
    max-width: 1320px;
    margin: 0 auto;
    padding: 0 20px;
    position: relative;
  }

  .ag-inner-container {
    overflow: hidden;
    width: 100%;
  }

  .ag-stage {
    display: flex;
    transition: transform 0.4s ease;
    will-change: transform;
  }

  .ag-item {
    flex: 0 0 calc(50% - 7.5px);
    margin-right: 15px;
    background: #fff;
  }
  .ag-item:last-child {
    margin-right: 0;
  }

  .ag-img {
    position: relative;
    width: 100%;
    padding-bottom: 56.25%;
    height: 0;
    overflow: hidden;
    background: #000;
  }
  .ag-img iframe {
    position: absolute;
    top: 0; left: 0;
    width: 100%;
    height: 100%;
    border: none;
  }

  .ag-title-desc-container {
    padding: 10px 0 4px;
  }
  .ag-item-desc {
    height: 54px;
    font-size: 0.88rem;
    color: #333;
    font-weight: 400;
    line-height: 1.45;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    font-family: 'Open Sans', Arial, sans-serif;
  }

  .ag-owl-nav {
    display: flex;
    justify-content: center;
    gap: 0;
    margin-top: 24px;
  }

  .owl-prev,
  .owl-next {
    width: 40px;
    height: 40px;
    background: #CF2230;
    border: none;
    cursor: pointer;
    color: #fff;
    font-size: 1.6rem;
    line-height: 1;
    font-weight: 300;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.2s;
    margin: 0 2px;
    border-radius: 2px;
    padding: 0;
    user-select: none;
  }
  .owl-prev:hover,
  .owl-next:hover {
    background: #a01a25;
  }
  .owl-prev.disabled,
  .owl-next.disabled {
    background: #d4d4d4;
    cursor: default;
    pointer-events: none;
  }

  @media (max-width: 700px) {
    .ag-item {
      flex: 0 0 100%;
      margin-right: 15px;
    }
  }
`;

export default function AutoExpertReviews() {
  const [index, setIndex] = useState(0);

  const isMobile =
    typeof window !== "undefined" && window.innerWidth <= 700;

  const visibleCount = isMobile ? 1 : 2;
  const maxIndex = Math.max(0, videos.length - visibleCount);

  const prev = () => setIndex((i) => Math.max(0, i - 1));
  const next = () => setIndex((i) => Math.min(maxIndex, i + 1));

  const translateX = isMobile
    ? `calc(-${index} * (100% + 15px))`
    : `calc(-${index} * (50% + 7.5px))`;

  return (
    <>
      <style>{css}</style>
      <div className="ag-section">
        <h2 className="ag-page-title">Auto Expert Reviews</h2>

        <div className="ag-main-container">
          <div className="ag-inner-container">
            <div
              className="ag-stage"
              style={{ transform: `translateX(${translateX})` }}
            >
              {videos.map((v, i) => (
                <div className="ag-item" key={i}>
                  <div className="ag-img">
                    <iframe
                      src={`https://www.youtube.com/embed/${v.id}?si=${v.si}`}
                      title={v.title}
                      allowFullScreen
                    />
                  </div>
                  <div className="ag-title-desc-container">
                    <div className="ag-item-desc">{v.title}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="ag-owl-nav">
            <button
              className={`owl-prev${index === 0 ? " disabled" : ""}`}
              onClick={prev}
              disabled={index === 0}
            >
              ‹
            </button>
            <button
              className={`owl-next${index >= maxIndex ? " disabled" : ""}`}
              onClick={next}
              disabled={index >= maxIndex}
            >
              ›
            </button>
          </div>
        </div>
      </div>
    </>
  );
}